import { ROWS, COLUMNS, getCoords } from '../utils';

import playSprite from '../../sprites/play.json'; 

export class LaunchMode {
  constructor() {
    this.state = {
      time: 0,
      index: 0,
      sheenTime: 10000,
    }
    while (playSprite[this.state.index] === false) {
      this.state.index += 1;
    }
  }
  update(delta, { audioData } = {}) {

    if (this.state.time > 10) {
      this.state.index += 1;
      this.state.time = 0;
    }
    while (playSprite[this.state.index] === false) {
      this.state.index += 1;
    }
    this.state.time += delta;

    if (this.state.index > playSprite.length && this.state.sheenTime > 2000) {
      this.state.sheenTime = 0;
    }
    if (delta) {
      this.state.sheenTime += delta;
    }
  }
  getData() {
    if (this.state.index < playSprite.length) {
      return playSprite.slice(0, this.state.index);
    }
    const data = [... playSprite];
    
    const inSheenRange = ({x, y}) => {
      const speed = 30;
      return (
        x < this.state.sheenTime / speed &&
        x > (this.state.sheenTime / speed) - 4
      )
    } 

    data.forEach((d, i) => {
      if (d && inSheenRange(getCoords(i))) {
        data[i] = 'orange';
      }
    })
    
    return data;
  }
}